module.exports = __webpack_public_path__ + "media/assets/images/flags/gh-43711a51ff720cebf1aaacfc86724468.svg";